export const getAccessToken = () => localStorage['access-token'];
export const saveAccessToken = token => localStorage.setItem('access-token', token);
export const getIdToken = () => localStorage['id-token'];
export const saveIdToken = token => localStorage.setItem('id-token', token);
export const setUserName = uname => localStorage.setItem('UserName', uname);
export const getUserName = () => localStorage.getItem('UserName');
